<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { SOCKET_URL, SOCKET_LOCAL_URL } from './utils/constant'
import { setInterval } from 'timers'
export default {
  name: 'App',
  data() {
    return {
      isDisconnected: false
    }
  },
  mounted() {
    this.$socket.on('connect', () => {
      this.$store.commit('netOff', false)
      console.log('==connect=---', this.$socket.connected)
    })

    this.$socket.on('disconnect', () => {
      console.log('***disconnected******', this.$socket.disconnected)
      this.$store.commit('netOff', true)
      if (this.$socket.disconnected) this.isDisconnected = true
      console.log('===--this.$socket--=isDisconnected--=', this.$socket)
      this.$socket.on('reconnect', () => {
        console.log('-----reconnecting----')
      })
    })
  }
}
</script>
